import React, { useContext, useMemo } from "react";
import KeycloakIDPAdapter from "common/Adapters/IDPAdapter/KeycloakIDPAdapter";
import { ServicesLinks, DownloadLink, useTranslator, usePathFactory } from "@sia/style-guide";
import GlobalContext from "contexts/GlobalContext";
import { resolveLang, VIDEO_BY_LANG } from "components/Media/VideoConfig";

const buildLinks = ({ isLoggedIn, videoUrl, isSurveyPage, isHomePage, lang }) => {
  const cmsURL = process.env.REACT_APP_CMS_URL;
  const baseLinks = [
    isLoggedIn && {
      id: 0,
      text: "benchmarking.side-bar.link.explanatory-video",
      externalHref: videoUrl,
      openInCurrentTab: false,
    },
    // {
    //   id: 1,
    //   text: "benchmarking.side-bar.link.survey-guidelines",
    //   href: `cms/benchmarking_faq#${process.env.REACT_APP_BENCHMARKING_FAQ_SECTION_GUIDANCE_ID}`,
    // },
    {
      id: 2,
      text: "benchmarking.side-bar.link.master-key-info",
      href: `cms/benchmarking_faq#${process.env.REACT_APP_BENCHMARKING_FAQ_SECTION_MASTER_KEY_ID}`,
    },

    (isSurveyPage || isHomePage) && {
      id: 3,
      text: "benchmarking.side-bar.link.guide",
      href: `${cmsURL}/${lang}${process.env.REACT_APP_BENCHMARKING_GUIDE_PDF}`,
    },
    { id: 4, text: "benchmarking.side-bar.link.terms", href: "cms/BenchmarkingAGB" },
    { id: 5, text: "benchmarking.side-bar.link.protection-privacy", href: "cms/datenschutzerklaerung" },
  ];
  return baseLinks.filter(Boolean);
};

const SideBarWithLinks = () => {
  const translate = useTranslator();
  const pathFactory = usePathFactory();
  const { language: lang } = useContext(GlobalContext) || {};
  const langKey = resolveLang(lang);
  const videoUrl = (VIDEO_BY_LANG[langKey] || VIDEO_BY_LANG.DE).src;
  const isLoggedIn = KeycloakIDPAdapter.isLoggedIn();
  const { pathname } = window.location;
  const isHomePage = /^\/(en|de|fr|it)\/?$/.test(pathname);
  const isSurveyPage = pathname.includes("/survey");

  const title = "benchmarking.side-bar.right.heading";

  const links = useMemo(() => buildLinks({ isLoggedIn, videoUrl, isSurveyPage, isHomePage, lang }), [isLoggedIn, videoUrl, isSurveyPage]);

  const isAbsolute = (url) => /^https?:\/\//i.test(url);

  return (
    <div className="sia-padding-03-left sia-padding-04-right textWithSyllabification" lang={lang}>
      {title ? <p className="sia-text-07 sia-padding-01-bottom">{translate(title)}</p> : null}
      {links.map((link) => {
        const text = translate(link.text);

        // External absolute URL (e.g., YouTube)
        if (link.externalHref && isAbsolute(link.externalHref)) {
          return (
            <div key={link.id} className="SideBarWithLinks-link-wrapper">
              <DownloadLink href={link.externalHref} text={text} variant="EXTERNAL" openInCurrentTab={link.openInCurrentTab} />
            </div>
          );
        }

        const resolvedHref = link.href
          ? isAbsolute(link.href)
            ? link.href
            : pathFactory.create(typeof link.href === "string" && !link.href.startsWith("cms/") ? translate(link.href) : link.href)
          : "#";

        return link.paragraph_type === "download_box" ? (
          <ServicesLinks key={link.id} items={[{ ...link, href: resolvedHref }]} />
        ) : (
          <div key={link.id} className="SideBarWithLinks-link-wrapper">
            <DownloadLink href={resolvedHref} text={text} variant="EXTERNAL" />
          </div>
        );
      })}
    </div>
  );
};

export default SideBarWithLinks;
